import { useCallback, useState, useContext } from "react";
import {
  useStore,
  getBezierPath,
  getStraightPath,
  MarkerType,
  Position,
  BaseEdge,
  EdgeLabelRenderer,
  getSmoothStepPath,
} from "reactflow";
import { getEdgeParams } from "./utils.js";
import Tooltip from "@mui/material/Tooltip";
import { ThemeContext } from "../../contexts/themeContext";

// Component for rendering success edges in the flow chart
function SuccessEdge({
  id,
  source,
  target,
  markerEnd,
  sourceX,
  sourceY,
  targetX,
  targetY,
}) {
  // State to manage tooltip visibility
  const [showTooltip, setShowTooltip] = useState(false);
  // Accessing path type from the global theme context
  const { pathType, setPathType } = useContext(ThemeContext);
  // Get source and target node details using reactflow hooks
  const sourceNode = useStore(
    useCallback((store) => store.nodeInternals.get(source), [source])
  );
  const targetNode = useStore(
    useCallback((store) => store.nodeInternals.get(target), [target])
  );

  // Return null if source or target node is not found
  if (!sourceNode || !targetNode) {
    return null;
  }

  let [edgePath, labelX, labelY] = [null, null, null];

  // Calculate edge path based on the selected path type
  switch (pathType) {
    case "smoothstep":
      [edgePath, labelX, labelY] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition: Position.Right,
        targetX,
        targetY,
        targetPosition: Position.Left,
      });
      break;
    case "straight":
      [edgePath, labelX, labelY] = getStraightPath({
        sourceX,
        sourceY,
        sourcePosition: Position.Right,
        targetX,
        targetY,
        targetPosition: Position.Left,
      });
      break;
    case "bezier":
      [edgePath, labelX, labelY] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition: Position.Right,
        targetX,
        targetY,
        targetPosition: Position.Left,
      });
      break;
    default:
      break;
  }

  // Styling options for the edge
  const edgeOptions = {
    style: { strokeWidth: 3, stroke: "#4a8e4e" },
    type: {
      type: MarkerType.ArrowClosed,
      color: "#3b7d3f",
    },
  };

  // Render the success edge along with a tooltip
  return (
    <>
      <BaseEdge
        id={id}
        className="react-flow__edge-path"
        path={edgePath}
        markerEnd={markerEnd}
        style={edgeOptions.style}
        type="success"
      />
      <EdgeLabelRenderer
        style={{
          pointerEvents: "all",
        }}
      >
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            background: "transparent",
            padding: 10,
            borderRadius: 5,
            fontSize: 12,
            fontWeight: 700,
            pointerEvents: "all",
            color: "transparent",
          }}
          onMouseOver={() => setShowTooltip(true)}
          onMouseOut={() => setShowTooltip(false)}
          className="nodrag nopan"
        >
          {showTooltip && (
            <Tooltip title="Sucesso na request" placement="top">
              asdsads
            </Tooltip>
          )}
        </div>
      </EdgeLabelRenderer>
    </>
  );
}

export default SuccessEdge;
